import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WebapiService } from '../shared/services/webapi.service';
import { ToastrService } from 'ngx-toastr';

declare var $: any;
declare var bootstrap: any;
@Component({
  selector: 'app-video-library',
  templateUrl: './video-library.component.html',
  styleUrls: ['./video-library.component.scss']
})
// export interface selectBox {
//   id : number,
//   name: string
// }

export class VideoLibraryComponent implements OnInit{ 
  noVideos=false;
  rulesList: any = []
  rules: any = ""
  levelsList: any = []
  levels: any = ""
  totalvideo = 0;
  page=1
  categoryList: any = []
  category: any = ""
  skillsList: any = []
  skill: any = ""
  disableLevel: boolean = true
  disableCategory: boolean = true
  disableSkills: boolean = true
  loader : boolean = false
  attri : any = []
  keyword=''
  attributes = {
    "atheletes" : {
      label: "No. of Athletes",
      values : ["1","2","3"]
    }, 
    "skill_height" :  {
      label: "Skill Height",
      values : ["1","2","3"]
    }
  }
  attributeList: any;
  videosList: any = [];
  videoDetails: any;
  filterableAttribtute:any={};

  constructor( private toastrService: ToastrService, public webApi: WebapiService, public router: Router) {}
  ngOnInit()  
  {    
    this.webApi.setLoader(true);
    $(document).ready(() => {   
      this.allRules();
        setTimeout( ()=> { 
          this.webApi.setLoader(false);
           $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
          }, 1000); 
        //https://preview.colorlib.com/theme/bootstrap/multiselect-06/
    });  
 
  } 

  allRules() { 
    this.attributeList=[]
    this.webApi.allConditions().subscribe((data: []) => {
      this.rulesList = data;
      if ($(".selectpicker.rules").length != 0 && this.rulesList) {
        setTimeout( ()=> { 
           $('.selectpicker.rules').selectpicker('refresh');  
        }, 500);  
      } 
      this.getVideos();
    });
  }

  toLower(title){
    return title.toLowerCase().charAt(0).toUpperCase() + title.toLowerCase().slice(1);;
  }

  getVideos(){
    this.noVideos = false;
    this.webApi.setLoader(true);
    let params= {
      "keyword":this.keyword.trim(),
      "rules":this.rules,
      "levels":this.levels,
      "skill":this.skill,
      "category":this.category,
      "attr":JSON.stringify(this.filterableAttribtute),
      "page":this.page
    }
    this.webApi.getVideos(params).subscribe((video: any) => {
      this.videosList = [...this.videosList,...video.videos]; 

      if(this.videosList.length==0){
        this.noVideos = true;
      }
      this.totalvideo = video.total; 
      this.webApi.setLoader(false);
    });
  }

  showMore() {
    this.page = this.page+1
    this.getVideos();
  }

  openDetails(id: Number,modalid:any){
    this.videoDetails = '';
    this.videoDetails = this.videosList.filter(function(video:any) {
      return video.id == id;
    })[0]; 
    
    if(this.videoDetails.allowed==0){
      setTimeout(()=>{
        if(document.getElementById('videos-locked-popup-modal')){
          var myModal = new bootstrap.Modal(document.getElementById('videos-locked-popup-modal'), {
            keyboard: true
          })
          myModal.show()
          //console.log('show-new-vids modal')
        }
      },300)
      return 
    }

    setTimeout(function(){
      $('#'+modalid).modal('show');
    }, 100);
  }

  addToFav($event,videoDetails:any) {  
    $event.preventDefault();
    $event.stopPropagation();
    this.webApi.setLoader(true);
    this.webApi.addVideoToFavourite(videoDetails.id).subscribe((data: any) => {
       if(data.success){
        videoDetails.fav=data.fav
        this.toastrService.success(data.message);
       }
       this.webApi.setLoader(false);
    },
    error => {
      this.webApi.setLoader(false);
      this.toastrService.error("unable to handle response");
    });
  }

  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  showSmallDescription(text: any){
    var div = document.createElement("div");
    div.innerHTML = text;
    var text1 = div.textContent || div.innerText || "";
    div.remove()
    return text1.substring(0,140)
  }

  allLevelsOfRule() {
    this.attributeList=[]
    if(this.rules) {
      let selectedrule = this.rulesList.find((rule:any) => rule.id == this.rules)
      if(selectedrule){
        this.levelsList = selectedrule['levels'];
        this.disableLevel = false;
        if ($(".selectpicker.level").length != 0 && this.rules) {
          setTimeout( ()=> { 
              $('.selectpicker.level').selectpicker('refresh');  
          }, 500);  
        } 
      }
 
    } 
    else {
      this.levelsList = []
      this.levels = ""
      this.disableLevel = true;
      setTimeout( ()=> {
        $('.selectpicker.level').selectpicker('refresh');  
       }, 0);  
    }  
  }

  allCategories() {
    this.attributeList=[]
    if(!this.categoryList.length && this.rules) {
      
      let selectedrule = this.rulesList.find((rule:any) => rule.id == this.rules)
      if(selectedrule)
        this.categoryList = selectedrule['categories']
        this.disableCategory = false;
        if ($(".selectpicker.category").length != 0 && this.rules) {
          setTimeout( ()=> {
              $('.selectpicker.category').selectpicker('refresh');
          }, 550); 
        }
    } 
    else   {  // Don't make Api call once we have categories
        this.category = "";
        this.disableSkills = true;
        this.skill = "";
        if(!this.levels) 
          this.disableCategory = true; 
        else 
          this.disableCategory = false;
          setTimeout( ()=> {
             $('.selectpicker.category, .selectpicker.skill').selectpicker('refresh');
          }, 0);  
    }
  }

  allSkills() {
    
    //if(!this.skillsList.length) {
      if(this.category){
        let selectedcat = this.categoryList.find((category:any) => category.id == this.category)
        if(selectedcat)
          this.skillsList = selectedcat['skills'];
          this.disableSkills = false; 
          this.showAttributes();
          if ($(".selectpicker.skill").length != 0 && this.rules) {
            setTimeout( ()=> {
              $('.selectpicker.skill').selectpicker('refresh');
            }, 550); 
          }
      }
      
    //} 
    //else {  // Don't make Api call once we have skills
      this.showAttributes();
      this.skill = "";
      if(!this.category)
        this.disableSkills = true;
      else 
        this.disableSkills = false;  
          setTimeout( ()=> {
             $('.selectpicker.skill').selectpicker('refresh');
          }, 0);  
    //}
   
  }
   
  showAttributes() {  
    this.filterableAttribtute={};
    $('.selectpicker.attributes').val('').trigger('change');
    let selectedcat = this.categoryList.find((category:any) => category.id == this.category)
    if(selectedcat)
      this.attributeList = selectedcat['attributes'];
      setTimeout( ()=> {
          $('.selectpicker.attributes').selectpicker('refresh');
      }, 550); 
       
  }

  getAttributesVal(e:any,option:any) {
    //console.log(this.attri);
    //console.log("options_value"+option+'_'+e?.target?.value);
    let found = Object.keys(this.filterableAttribtute).map((index:any,item:any)=> { return index == option})
    if(found.length){
      delete this.filterableAttribtute[option];
    }
    // else{
    //   this.filterableAttribtute[option]=option+'_'+e?.target?.value;
    // }
    this.filterableAttribtute[option]=option+'_'+e?.target?.value;

    //console.log(this.filterableAttribtute)
  }

  search(){
    this.page = 1;
    this.videosList=[]
    // console.log('keyword',this.keyword)
    // console.log('rule',this.rules)
    // console.log('levels',this.levels)
    // console.log('skill',this.skill)
    // console.log('category',this.category)
    // console.log('attr',this.filterableAttribtute)
    // let params= {
    //   "keyword":this.keyword,
    //   "rules":this.rules,
    //   "levels":this.levels,
    //   "skill":this.skill,
    //   "category":this.category,
    //   "attr":JSON.stringify(this.filterableAttribtute),
    // }
    //params
    this.getVideos()
  }

  resetSearch(){
    this.category = "";
    this.levels = "";
    this.rules = "";
    this.keyword = "";
    this.skill = "";
    this.filterableAttribtute={};
    this.attributeList = [];
    this.disableCategory = true;
    this.disableSkills = true;
    this.disableLevel = true;
    this.disableSkills = true;
    this.page=1
    this.getVideos()
    setTimeout( ()=> {
      $('.selectpicker.rules,.selectpicker.level, .selectpicker.category, .selectpicker.skill, .selectpicker.attributes').selectpicker('refresh');
   }, 0);
  }
}


//SELECT * FROM `attribute_values` where attribute_id In (SELECT id from attributes WHERE cat_ids = 1);
//SELECT * FROM `attribute_values` as A LEFT JOIN attributes as B ON A.attribute_id = B.id WHERE B.cat_ids = 1;